import React, { useEffect, useState } from 'react';
import '../styles/InstallAppMenuItem.css';

// Détecte si l'app tourne déjà en mode installé (PWA), peu importe la session
// en cours — contrairement à l'événement "appinstalled" qui ne se déclenche
// qu'au moment de l'installation elle-même.
const isRunningStandalone = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator?.standalone === true;

function InstallAppMenuItem() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);
  const [isInstalled, setIsInstalled] = useState(isRunningStandalone);
  const [expandedInstallMessage, setExpandedInstallMessage] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      // e.preventDefault(); // Empêche le navigateur d'afficher la bannière par défaut
      setDeferredPrompt(e);
      setCanInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
      setCanInstall(false);
      setDeferredPrompt(null);
    });

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'accepted') {
      setIsInstalled(true);
      setCanInstall(false);
    }

    setDeferredPrompt(null);
  };

  if (isInstalled) {
    return <p>📲 Application installée</p>;
  }

  return (
    <>
      <p>
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (canInstall) {
              handleInstallClick();
            } else {
              if (window.umami) window.umami.track('install-AppMessage');
              setExpandedInstallMessage(!expandedInstallMessage);
            }
          }}
          className="kdo-button-like-link"
        >
          📲 Installer l'application
        </button>
      </p>

      {expandedInstallMessage && !canInstall && (
        <>
          <p className="kdo-install-hint">
            Sur iPhone, ouvrez le menu <strong>Partager</strong> de Safari puis cliquez sur <strong>« Sur l'écran d'accueil »</strong> pour installer l'app.
          </p>
          <p className="kdo-install-hint">
            Sur Android, ouvrez le menu <strong>...</strong> de Chrome puis cliquez sur <strong>« Ajouter à l'écran d'accueil »</strong> pour installer l'app.
          </p>
        </>
      )}
    </>
  );
}

export default InstallAppMenuItem;
